<ui-detail-section
    [title]="'Inhalte & Methodik'"
>
    <ui-detail-description
        [title]="'Welche Inhalte werden vermittelt?'"
        [htmlDescription]="mapItem().content"
    />
    <ui-detail-description
        [title]="'Methoden / pädagogischer Ansatz:'"
        [htmlDescription]="mapItem().methods"
    />
    <ui-detail-boolean
        [title]="'Beteiligung von Lehrkräften oder anderen pädagogischen Fachkräften in der Durchführung?'"
        [value]="mapItem().needsTeacherInvolvement"
    />
    @if (mapItem().hasFurtherOffers && mapItem().furtherOffers; as offers) {
        <ui-detail-description
            [title]="'Begleitende Angebote (Elternabende, Fortbildungen, Materialpakete):'"
            [htmlDescription]="offers"
        />
    }
</ui-detail-section>
